import { html } from 'lit';
const AccountBan =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.75 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m4.75-3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5" clip-rule="evenodd"/><path fill='currentColor' d="M12.003 13.978a.75.75 0 0 1-.723.776 6.25 6.25 0 0 0-5.778 4.484.67.67 0 0 0 .161.666c.183.2.486.346.837.346h4.754a.75.75 0 0 1 0 1.5H6.5a2.64 2.64 0 0 1-1.943-.833 2.16 2.16 0 0 1-.495-2.102 7.75 7.75 0 0 1 7.166-5.56.75.75 0 0 1 .775.723"/><path fill='currentColor' fill-rule="evenodd" d="M12.35 17.5a4.65 4.65 0 1 1 9.3 0 4.65 4.65 0 0 1-9.3 0M17 14.15a3.35 3.35 0 0 0-2.784 5.215l4.649-4.649A3.34 3.34 0 0 0 17 14.15m2.784 1.486-4.648 4.648a3.35 3.35 0 0 0 4.648-4.648" clip-rule="evenodd"/>
  </svg>
`;
export default AccountBan;
